import { render, staticRenderFns } from "./pos-fmi-add-passage-modal.vue?vue&type=template&id=40146f06&scoped=true&"
import script from "./pos-fmi-add-passage-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-fmi-add-passage-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40146f06",
  null
  
)

export default component.exports